import { SocketId } from '@feedyou/schema'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BotState, RoomState, SocketServerState } from './types'

export const initialState: SocketServerState = {
  isConnected: false,
  isBotStateUpToDate: false,
  socketId: null
}

const slice = createSlice({
  name: 'socketServer',
  initialState,
  reducers: {
    newRoomState: (state, action: PayloadAction<RoomState>) => {
      state.isConnected = true
      state.roomState = action.payload
      state.isBotStateUpToDate = true
    },
    connect: (state, action: PayloadAction<{ socketId: SocketId }>) => {
      state.isConnected = true
      state.socketId = action.payload.socketId
    },
    disconnect: state => {
      return initialState
    },
    newBotState: (state, action: PayloadAction<BotState>) => {
      if (!state.roomState) {
        return
      }

      state.roomState.botState = action.payload
      state.isBotStateUpToDate = true
    },
    markBotStateAsOutdated: state => {
      state.isBotStateUpToDate = false
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
